import { FeatureFlag } from 'constants-flags';
import useFlag from 'lane-shared/hooks/useFlag';

/**
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2025-06-06T17:10:50+0530.
 */
export function useServiceRequestTaskTimeEnable() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.EnableServiceRequestTaskTime,
    false
  );

  return Boolean(isEnabled);
}